/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Lesebeispiel`}</h1>
    <p>{`In der `}<strong parentName="p">{`Stadt Zürich`}</strong>{` zahlt eine `}<strong parentName="p">{`ledige Person`}</strong>{` mit einem `}<strong parentName="p">{`Bruttoeinkommen von 100'000 Franken`}</strong>{` bei `}<strong parentName="p">{`11,0% Steuerbelastung`}</strong>{` rund `}<strong parentName="p">{`11'000 Franken Kantons-, Gemeinde- und Kirchensteuern.`}</strong></p>
    <p>{`Je nach Abzügen kann dieser Betrag variieren.`}</p>
    <p>{`Für die Berechnung `}<strong parentName="p">{`nicht berücksichtigt`}</strong>{` wurden die `}<strong parentName="p">{`Vermögenssteuer`}</strong>{` sowie die `}<strong parentName="p">{`Bundessteuer`}</strong>{`, welche ohnehin in allen Gemeinden gleich hoch ist.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  